import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=351b07f2&scoped=true&"
import script from "./AboutView.vue?vue&type=script&lang=js&"
export * from "./AboutView.vue?vue&type=script&lang=js&"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=351b07f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b07f2",
  null
  
)

export default component.exports